<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQueryCus">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory']"  >
              <a-select showSearch optionFilterProp="children" v-model="queryParam.factoryId" :options="factoryOptions" :placeholder="language['common.pleaseInput']+language['factory']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['legalperson']">
              <a-select showSearch optionFilterProp="children" v-model="queryParam.legalpersonId" :options="legalpersonOptions" :placeholder="language['common.pleaseInput']+language['legalperson']" allowClear>
               </a-select>
            </a-form-item>
          </a-col>
          
          <!-- <template v-if="toggleSearchStatus"> -->
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24"><a-form-model-item :label="language['businessGroupName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="businessGroupId">
                <a-select  :placeholder="language['common.pleaseInput']+language['businessGroupName']" v-model="queryParam.businessGroupId" @change="backDepartGroup" :backDepart="true" :treeOpera="true">
                  <a-icon slot="suffixIcon" type="gold" />
                  <a-select-option
                    v-for="d in groupDepartOptions"
                    :key="d.id"
                    :value="d.id">
                    {{ d.departName }}
                  </a-select-option>
                </a-select>
               </a-form-model-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24" >
              <a-form-model-item :label="language['businessUnitName']" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="businessUnitId">
               <a-select :placeholder="language['common.pleaseInput']+language['businessUnitName']" v-model="queryParam.businessUnitId" @change="backDepartUnit" :backDepart="true" :treeOpera="true">
                 <a-icon slot="suffixIcon" type="gold" />
                 <a-select-option
                   v-for="d in nextDepartOptions"
                   :key="d.id"
                   :value="d.id">
                   {{ d.departName }}
                 </a-select-option>
               </a-select>
               </a-form-model-item>            
            </a-col>
            
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="language['dangerType']">
                <j-dict-select-tag :placeholder="language['common.pleaseInput']+language['dangerType']" v-model="queryParam.dangerType" dictCode="ep_danger_type" allowClear/>
              </a-form-item>
            </a-col>
            
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item :label="language['inspectTime']">
                <j-date :placeholder="language['common.chooseStartDate']" class="query-group-cust" v-model="queryParam.startTime" ></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :placeholder="language['common.chooseEndDate']" class="query-group-cust" v-model="queryParam.endTime"></j-date>
              </a-form-item>
            </a-col>
            
          <!-- </template> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQueryCus" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchResetCus" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              </span>
          </a-col>
        </a-row>
        <a-row>
          <a-button type="primary" icon="download" @click="handleExportXls('隱患類型分析表')" style="margin-left: 8px">{{language['common.exportButton']}}</a-button>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- table区域-begin -->
    <a-tabs @change="callback">
      <a-tab-pane key="1" :tab="language['list.info.title']">
        <div>
          <table ref="table"
            size="middle"
            rowKey="id"
            class="j-table-force-nowrap"
            :scroll="{x:true}"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            @change="handleTableChange" style="width:100%;border:1px solid #e8e8e8;">
            <colgroup>
            <col style="width: 60px; min-width: 60px;">
            <col><col><col><col><col><col><col><col></colgroup>
            <thead class="ant-table-thead">
              <tr>
              <th rowspan="2" key="rowIndex" class="ant-table-align-center ant-table-row-cell-break-word" style="text-align: center;">
                <span class="ant-table-header-column">
                  <div><span class="ant-table-column-title">#</span>
                  <span class="ant-table-column-sorter"></span></div></span></th>
                  
               <th rowspan="2"  key="factoryName" class="ant-table-align-center" style="text-align: center;">
                    <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['factory']}}</span>
                    <span class="ant-table-column-sorter"></span></div></span>
                    </th>
                <th rowspan="2"  key="personName" class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['legalperson']}}</span>
                  <span class="ant-table-column-sorter"></span></div></span>
                  </th>
               <th rowspan="2"  key="businessGroupName" class="ant-table-align-center" style="text-align: center;">
                 <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['businessGroupName']}}</span>
                 <span class="ant-table-column-sorter"></span></div></span>
                 </th>
               <th rowspan="2"  key="businessUnitName" class="ant-table-align-center" style="text-align: center;">
                 <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['businessUnitName']}}</span>
                 <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th key="dangerType" colspan="11"  class="ant-table-align-center" style="text-align: center;border-bottom: 1px solid #e8e8e8;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['dangerType']}}</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
            <th rowspan="2"  class="ant-table-align-center ant-table-row-cell-last" style="text-align: center;">
              <span class="ant-table-header-column"><div><span class="ant-table-column-title">{{language['totalSum']}}</span>
              <span class="ant-table-column-sorter"></span></div></span>
            </th>
           </tr>
           <tr>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">MF</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TW</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TA</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TN</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TS</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TR</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">TH</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">DW</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">DA</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">EO</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
               <th class="ant-table-align-center" style="text-align: center;">
                  <span class="ant-table-header-column"><div><span class="ant-table-column-title">EM</span>
                  <span class="ant-table-column-sorter"></span></div></span>
               </th>
           </tr>
          </thead>
          <tbody class="ant-table-tbody">
           <tr v-for="(item, index) in dataSource" class="ant-table-row ant-table-row-level-0">
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{index+1}}</td>
           <td class="" style="text-align: center;">{{item.factoryName}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{item.legalpersonName}}</td>
           <td class="" style="text-align: center;">{{item.businessGroupName}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{item.businessUnitName}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"MF")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TW")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TA")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TN")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TS")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TR")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"TH")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"DW")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"DA")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"EO")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{getDangerSum(item,"EM")}}</td>
           <td class="ant-table-row-cell-break-word" style="text-align: center;">{{item.dangerTypeNum}}</td>
          </tr>
         
            <tr class="ant-table-row ant-table-row-level-0">
              <td class="ant-table-row-cell-break-word" style="text-align: center;"></td>
              <td colspan="4" class="" style="text-align: center;">{{language['totalSum']}}</td>
              <td class="" style="text-align: center;">{{total.MF}}</td>
              <td class="" style="text-align: center;">{{total.TW}}</td>
              <td class="" style="text-align: center;">{{total.TA}}</td>
              <td class="" style="text-align: center;">{{total.TN}}</td>
              <td class="" style="text-align: center;">{{total.TS}}</td>
              <td class="" style="text-align: center;">{{total.TR}}</td>
              <td class="" style="text-align: center;">{{total.TH}}</td>
              <td class="" style="text-align: center;">{{total.DW}}</td>
              <td class="" style="text-align: center;">{{total.DA}}</td>
              <td class="" style="text-align: center;">{{total.EO}}</td>
              <td class="" style="text-align: center;">{{total.EM}}</td>
              <td class="" style="text-align: center;">{{total.sumTotal}}</td>
              </tr>
           </tbody>
          </table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="2" :tab="language['pie.chart']" >
          <template>
            <div>
              <!-- <h2 style="margin-left: 700px">{{this.businessUnitName}}</h2> -->
              <pie  :dataSource="this.sourceDataType"   style="margin-right: 160px"/>
            </div>
          </template>      
      </a-tab-pane>
      
      <a-tab-pane key="3" :tab="language['histogram']">
              <div style="overflow-x: scroll; width: 100%; height: 100%; ">
                <v-chart :height="height" width="1300" :data="data">
                  <v-tooltip />
                  <v-axis />
                  <v-legend />
                  <v-stack-bar position="事業處*隱患數量" color="name" />
                </v-chart>
              </div>
      </a-tab-pane>
      
    </a-tabs>

    <!-- <ep-danger-check-modal ref="modalForm" @ok="modalFormOk"/> -->
  </a-card>
</template>

<script>
  import Pie from '@/components/chart/Pie'
  import Bar from '@/components/chart/Bar'
  import { getAction, postAction,downFile } from '@/api/manage'
   import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util';
  import {ajaxGetDictItems} from '@/api/api'
  
  export default {
    name: "EpDangerTypeReportTo",
    components: {
      Pie
    },
    data () {
      this.chartExtend = {
        series:[
          {
            name:"ceshi ",
            label:{
              normal:{
                show:true,
                formatter:'{b}: {c}  {d}%'
              }              
            }
          }
        ]
      };
      return {
        sourceData:[],
        sourceDataType: [],
        fields:[],
        fields_list:[],
        height: 400,
        description: '隱患類型分析表',
        /* 查询条件-请不要在queryParam中声明非字符串值的属性 */
      queryParam: {
        appCode:'env_audit'
      },
      /* 数据源 */
      dataSource:[],
      dataList:[],
      scale:[],
      pieStyle: {
        stroke: "#fff",
        lineWidth: 1
      },
      labelConfig: ['percent', {
        offset: -40,
        textStyle: {
          rotate: 0,
          textAlign: 'center',
          shadowBlur: 2,
          shadowColor: 'rgba(0, 0, 0, .45)'
        }
      }],
      businessUnitName:'',
      total:{
        MF:0,
        TW:0,
        TA:0,
        TN:0,
        TS:0,
        TR:0,
        TH:0,
        DW:0,
        DA:0,
        EO:0,
        EM:0,
        sumTotal:0
      },
      // 表格缓存的数据 - 用来点击取消时回显数据
      cacheData: [],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "條"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      /* 排序参数 */
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
      /* table加载状态 */
      loading:false,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      /* 查询折叠 */
      toggleSearchStatus:false,
      
        // 表头
        columns: [
        ],
        url: {
          list: "/epm/report/getDangerTypeReport",
          listUnit: "/epm/report/queryDangerUnitList",
          exportXlsUrl: "/epm/report/exportXlsDangerType",
          queryFactoryList: '/sys/epFactory/list',
          queryLegalpersonList: '/sys/epPerson/list',
          queryCurUserUnit: '/sys/employee/getCurrUserUnitDept',
          getGroupUnitList:'/epm/epScopeConfig/getGroupUnitByInSpectUnitID',
        },
        dangerTypeOptions:{},
        superFieldList:[],
        factoryOptions: [],
        legalpersonOptions:[],
        disabledState:true,
        id:'',
        curUserUnitDeptName:'',
        curUserUnitDeptOrgCode:'',
        DepartOptions:[],
        groupDepartOptions:[],
        nextDepartOptions:[],
        curinspectDepartId:'',
        
      }
    },
    created() {
      this.initQueryDate();
      this.initfactoryList();
      this.initlegalpersonList();      
      this.getCurrUserUnitDept();
      this.searchQueryCus(1);
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      callback(key) {
        console.log("key==>" + key);
        if(key==2){
          
        }
        if(key==3){
          
        }
      },
      getDangerSum(record,type)
      {
        let num = 0;
        //console.log("dataList:" + this.dataList);
        this.dataList.filter(function (item) {
           if(item.factoryName == record.factoryName
           && item.legalpersonCode == record.legalpersonCode
           && item.businessGroupName == record.businessGroupName
           && item.businessUnitName == record.businessUnitName
           && item.dangerType == type)
           {
             num = item.dangerTypeNum;
           }
        });
        return num;
      },
      //取当前登录人员的事业处
      getCurrUserUnitDept()
      {
        let para = {applicationCode:'env_audit'}
        getAction(this.url.queryCurUserUnit,para).then(res=>{
          if(res){
            this.curUserUnitDeptName = res.departName;
            this.curUserUnitDeptOrgCode = res.orgCode;
            this.curinspectDepartId = res.id;
            console.log(' getCurrUserUnitDept curinspectDepartId===========' + this.curinspectDepartId);
            this.getGroupUnitList();
            //this.initemployeeList();
          }
        })
      },
      //取得被稽查的事业群事业处
      getGroupUnitList()
      {
        console.log('getGroupUnitList curinspectDepartId===========' + this.curinspectDepartId);
        
        let para = {inSpectUnitId:this.curinspectDepartId}    
        getAction(this.url.getGroupUnitList,para).then(res=>{
          if(res.success)
          {
            this.DepartOptions = res.result;
            res.result.forEach(item=>{
              if(item.levelNo == "15")
              {
                this.groupDepartOptions.push(item)
              }
            });
          }
          console.log('this.DepartOptions==============' + this.DepartOptions);
        })
        
      },
      initQueryDate(){
        this.queryParam = {startTime: this.getOneMonthDate(),endTime: this.getNowDate()}
      },
      getNowDate()
      {
          let month =parseInt(new Date().getMonth())+1;
          return new Date().getFullYear()+"/"+month+"/"+new Date().getDate();
      },
      getOneMonthDate()
      {
        const dates = new Date()
        dates.setMonth(dates.getMonth() - 1)
        let pastMonth = dates.getMonth() + 1
        let pastDay = dates.getDate()
        if (pastMonth >= 1 && pastMonth <= 9) {
          pastMonth = '0' + pastMonth
        }
        if (pastDay >= 0 && pastDay <= 9) {
          pastDay = '0' + pastDay
        }
        const endDate = dates.getFullYear() + '-' + pastMonth + '-' + pastDay
        return endDate
         //return new Date().getFullYear()+"/"+new Date().getMonth()+"/"+new Date().getDate();
      },
      getQueryParams()
       {
       //获取查询条件
       let sqp = {}
       var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
       param.field = this.getQueryField();
       //稽查标识
       param.inspectFlag =0;
       return filterObj(param);
      },
      getQueryField() 
      {
       //TODO 字段权限控制
       var str = "id,";
       this.columns.forEach(function (value) {
         str += "," + value.dataIndex;
       });
       return str;
      },
      searchQueryCus(arg)
      {
      this.queryParam.appCode = 'env_audit';
      var params = this.getQueryParams();//查询条件
      this.loading = true;
      //取得厂区，法人，事业群，事业处
      postAction(this.url.listUnit, params).then((res) => {
        if (res.success) {          
          const result = res.result.records || res.result
          this.dataSource = result.map((v, i)=>{
            v.key = i + 1;
            return v;
          }) || res.result;    
          
          console.log('----this.dataSource---' + this.dataSource);
          //取得数据列表                
          postAction(this.url.list, params).then((res2) => {
              if (res2.success) {              
                const result = res2.result.records || res2.result
                this.dataList = result.map((v, i)=>{
                  v.key = i + 1;
                  return v;
                }) || res.result;
                
                this.total.MF = this.dataList.filter(function(item){ return item.dangerType == "MF"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TW = this.dataList.filter(function(item){ return item.dangerType == "TW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TA = this.dataList.filter(function(item){ return item.dangerType == "TA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TN = this.dataList.filter(function(item){ return item.dangerType == "TN"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TS = this.dataList.filter(function(item){ return item.dangerType == "TS"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TR = this.dataList.filter(function(item){ return item.dangerType == "TR"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.TH = this.dataList.filter(function(item){ return item.dangerType == "TH"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DW = this.dataList.filter(function(item){ return item.dangerType == "DW"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.DA = this.dataList.filter(function(item){ return item.dangerType == "DA"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EO = this.dataList.filter(function(item){ return item.dangerType == "EO"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.EM = this.dataList.filter(function(item){ return item.dangerType == "EM"}).map(function(item){ return item.dangerTypeNum}).reduce(function(prev,curr,idx,arr){return prev+curr;},0);
                this.total.sumTotal = parseInt(this.total.MF) + parseInt(this.total.TW)+parseInt(this.total.TA)+parseInt(this.total.TN)+parseInt(this.total.TS) +parseInt(this.total.TR) + parseInt(this.total.TH) +parseInt(this.total.DW)+parseInt(this.total.DA)+parseInt(this.total.EO)+ parseInt(this.total.EM);
                     
                this.sourceDataType = [];           
                let attr=['MF','TW','TA','TN','TS','TR','TH','DW','DA','EO','EM'];
                //饼状图数据
                attr.forEach((k)=>{
                      let levelitem = {item:k,count:0};
                      if (this.dataList == 0) 
                      {
                        this.sourceDataType.push(levelitem);
                      } 
                      else 
                      {
                        if(k=="MF")
                        {
                          levelitem['count']=this.total.MF;
                        }
                        else if(k=="TW")
                        {
                          levelitem['count']=this.total.TW;
                        }
                        else if(k=="TA")
                        {
                          levelitem['count']=this.total.TA;
                        }
                        else if(k=="TN")
                        {
                          levelitem['count'] = this.total.TN;
                        }
                        else if(k=="TS")
                        {
                          levelitem['count'] = this.total.TS;
                        }
                        else if(k=="TR")
                        {
                          levelitem['count'] = this.total.TR;
                        }
                        else if(k=="TH")
                        {
                          levelitem['count'] = this.total.TH;
                        }
                        else if(k=="DW")
                        {
                          levelitem['count'] = this.total.DW;
                        }
                        else if(k=="DA")
                        {
                          levelitem['count'] = this.total.DA;
                        }
                        else if(k=="EO")
                        {
                          levelitem['count'] = this.total.EO;
                        }
                        else if(k=="EM")
                        {
                          levelitem['count'] = this.total.EM;
                        }
                        this.sourceDataType.push(levelitem);
                      }                 
                  });
                  if (this.dataSource.length ==0) {
                    this.fields_list.push('');   //没有数据，默认
                  } else {
                    this.dataSource.forEach((item)=>{
                      this.fields_list.push(item.businessUnitName);
                    });
                  }
                  //柱状图数据
                  attr.forEach((k)=>{
                    let levelitem = {name:k};
                    if (this.dataList == 0) {
                      levelitem[""] = 0;
                      this.sourceData.push(levelitem);
                    } 
                    else 
                    {
                      this.dataList.map((item,index,arr)=>{
                        if(item.dangerType == k)
                        {
                          let person = item.legalpersonName==null?"":item.legalpersonName;
                          let name = '\n\n\n\n' + item.factoryName +",\n"+person+",\n"+item.businessGroupName+",\n"+item.businessUnitName;
                         // let name = item.factoryName+","+ person +","+item.businessGroupName+","+item.businessUnitName;
                          let num = item.dangerTypeNum;
                          if(num != "0")
                          {
                          levelitem[name] = num;
                          }
                        }
                      });
                      this.sourceData.push(levelitem);
                    }
                  });
                  
                  console.log('11111111 sourceDataType --->' , this.sourceData)
                  
                  if (this.dataSource.length ==0) {
                    this.fields.push('');   //没有数据，默认
                  } else {
                    this.dataSource.forEach((item)=>{
                      let person = item.legalpersonName==null?"":item.legalpersonName;
                      let name = '\n\n\n\n' + item.factoryName +",\n"+person+",\n"+item.businessGroupName+",\n"+item.businessUnitName;
                     // let name = item.factoryName+","+ person +","+item.businessGroupName+","+item.businessUnitName;
                      this.fields.push(name);
                    });
                  }
                  console.log('33333 fields --->' , this.fields)
                  
                  const DataSet = require('@antv/data-set');
                  const dv = new DataSet.View().source(this.sourceData);
                  dv.transform({
                    type: 'fold',
                    fields: this.fields,
                    key: '事業處',
                    value: '隱患數量',
                  });
                  this.data = dv.rows;
                  
                }else{
                    this.$message.warning(res.message)
                  }
                }).finally(() => {
                  this.loading = false;
                  this.fields =[];
                  this.sourceData=[]; 
                 });
        }else{
          this.$message.warning(res.message)
        }
      })
    },
    searchResetCus() 
    {
      this.queryParam = {}
      this.queryParam.appCode = 'env_audit';
      this.searchQueryCus(1);
    },

    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    handleExportXls(fileName){
      if(!fileName || typeof fileName != "string"){
        fileName = "導出文件"
      }
      this.queryParam.appCode = 'env_audit';
      let param = this.getQueryParams();
      if(this.selectedRowKeys && this.selectedRowKeys.length>0){
        param['selections'] = this.selectedRowKeys.join(",")
      }
      console.log("导出参数",param)
      downFile(this.url.exportXlsUrl,param).then((data)=>{
        console.log("down 000000");
        if (!data) {
          this.$message.warning("文件下載失敗")
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
      
    handleTableChange(pagination, filters, sorter) {
      this.searchQueryCus(1);
    },
      //初始化厂区字典
      initfactoryList(){
		  let para={pageNo:1,pageSize:1000};
        getAction(this.url.queryFactoryList,para).then(res=>{
          if(res.success){
            this.factoryOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.factoryName, value: item.id+""}
              return c;
            })
            console.log('this.factoryOptions: ',this.factoryOptions)
          }
        })
      },

      //初始化法人字典
      initlegalpersonList(){
		  let para = {pageNo:1,pageSize:10000};
        getAction(this.url.queryLegalpersonList,para).then(res=>{
          if(res.success){
            this.legalpersonOptions = res.result.records.map((item,index,arr)=>{
              let c = {label:item.legalpersonName, value: item.id+""}
              return c;
            })
            console.log('this.legalpersonOptions: ',this.legalpersonOptions)
          }
        })
      },
      backDepartGroup()
      {
        //清空事业处
        //this.queryParam.businessUnitName = "";
        //this.queryParam.businessUnitId = "";
        this.nextDepartOptions=[];
        //重新填充事业处数据
        this.DepartOptions.forEach(item=>{
          console.log("item.parentId ==========" + item.parentId);
          if(item.levelNo == "40" && item.parentId == this.queryParam.businessGroupId)
          {
            this.nextDepartOptions.push(item);
            console.log(this.nextDepartOptions);
          }
        });    
      },
      backDepartUnit(info)
      {
        
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  
  th {
      border-right: 1px solid #e8e8e8;
  } 
  td {
      border-right: 1px solid #e8e8e8;
  } 
  /deep/ .g2-tooltip{
      width: 200px !important;
    }
  
</style>